import React, {useContext} from "react";
import {useSelector} from "react-redux";
import {makeStyles} from "@material-ui/core";
import {multiLanguageValue} from "../../../../../../JsonScreen/Utils/lib";
import {ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary} from "../../../../../../../Utils/ExpansionPanel";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import {useDrop} from "react-dnd";
import {AcceptTypes} from "../../ToolBar/ToolBarUtils/ItemTypes";
import RenderComponents from "./RenderByType/RenderComponents";
import {ScreenDesignerContextNew} from "../../../../../../../ContextComponents/ScreenDesignerContextNew";
const useStyles = makeStyles(() => ({
    panelDetails: {
        padding: '0',
        display: 'flex',
        width: '100%'
    }
}))
const AccordionComponent = (props) => {
    const {path, index: parentIndex} = props;
    const {styles: sourceStyles, properties: {label, content} = {}, children = []} = props.component;
    const {onDropComponent, onDropMultipleComponents, onMoveComponent} = useContext(ScreenDesignerContextNew);
    const {userLanguage} = useSelector(state => state.app)
    const multiLanguageLabel = multiLanguageValue(label, userLanguage);
    const multiLanguageContent = multiLanguageValue(content, userLanguage);
    const classes = useStyles();
    const styles = sourceStyles.length ? sourceStyles[0] : {};
    const hasChildren = children && children.length;

    const [{isOverCurrent}, drop] = useDrop({
        accept: AcceptTypes.column,
        collect: monitor => ({
            isOverCurrent: monitor.isOver({shallow: true}),
        }),
        drop: (item, monitor) => {
            const didDrop = monitor.didDrop();
            let newItem = {...item};
            if (didDrop) {
                return;
            }
            if (item.children && item.type === 'panel') {
                newItem = {
                    ...newItem, children: [{
                        type: 'panel',
                        styles: [{
                            width: "100%",
                            justifyContent: 'flex-start',
                            flexDirection: 'column',
                            alignItems: 'flex-start'
                        }],
                        children: []
                    }]
                };
            }
            if (item.dragType === 'multiple') {
                onDropMultipleComponents(item.component, 0, `${path}.children`);
                return
            }
            if (item.dragType === 'move') {

                //insert panel inside container
                if (item.component.type === 'panel') {
                    item.component = {
                        ...item.component, children: [{
                            type: 'panel',
                            styles: [{
                                width: "100%",
                                justifyContent: 'flex-start',
                                flexDirection: 'column',
                                alignItems: 'flex-start'
                            }],
                            children: item.component.children
                        }]
                    };
                }

                onMoveComponent(item.component, item.from, `${path}.children`, children.length, item.index, parentIndex);
                return
            }
            console.log(children.length)
            onDropComponent(newItem, children.length, `${path}.children`)
        }
    });

    return (
        <>
            <ExpansionPanel>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon/>}
                >
                    <Typography>{multiLanguageLabel}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails classes={{root: classes.panelDetails}}>
                    <div ref={drop} style={{height: styles.height, width: '100%', display: 'flex', flexDirection: 'column', alignItems:'baseline'}}>
                        {multiLanguageContent}
                        {hasChildren ? (
                            children.map((item, index) => {
                                return (
                                    <RenderComponents
                                        key={index}
                                        type={item.type}
                                        item={item}
                                        index={index}
                                        path={`${path}.children.${index}`}
                                        parentPath={path}
                                    />
                                )
                            })
                        ) : (
                            isOverCurrent && (
                                <div style={{background: '#009688', height: 10, alignSelf: 'center', width: '100%'}}>

                                </div>
                            )
                        )}
                    </div>
                </ExpansionPanelDetails>
            </ExpansionPanel>
        </>
    )
};

export default AccordionComponent;